import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Modal } from 'components/ui';
import * as Styled from './NewPasswordModal.styles';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import TextField from "@mui/material/TextField";
import { useResetPassword } from 'api';
import ToastMessage from 'components/toastMessage';

const schema = Yup.object({
  newPassword: Yup.string().required("Pole wymagane").matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/, "Zbyt mała złożoność hasła"),
});

export const NewPasswordModal = ({ data, onClose, onSuccess }) => {
  const { values, errors, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      newPassword: data.newPassword || '',
    },
    validationSchema: schema,
    validateOnChange: false,
    onSubmit: (values) => {
      updatePassword(schema.cast(values));
    },
  });

  const { mutate: updatePassword, isLoading: isUpdatingPassword } = useResetPassword({
    onSuccess: () => {
      setFieldValue('');
      setIsSaving(false);
      onSuccess();  // shows the toast
      onClose();
    },
    onError: () => {
      setToastData({ severity: 'error', message: 'Nie udało się zapisać hasła' });
      setIsSaving(false);
    },
  });

  const [showPassword, setShowPassword] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (e) => { e.preventDefault(); };
  const [toastData, setToastData] = React.useState(null);

  return (
    <Modal title={data.newPassword ? 'Edytuj swoje hasło' : 'Nowe hasło'} onClose={onClose}>
      {toastData && (
        <ToastMessage
          open
          onClose={() => setToastData(null)}
          severity={toastData.severity}
          message={toastData.message}
        />
      )}
      <Styled.Form>
        <TextField required error={errors.newPassword} onChange={(e) => setFieldValue('newPassword', e.target.value)} fullWidth name="password" label="Twoje nowe hasło" type={showPassword ? 'text' : 'password'} id="password" 
            InputProps={{
                endAdornment: 
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="Pokaż hasło"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
            }} 
        />
        <Styled.h6>Hasło powinno mieć co najmniej 12 znaków, wielkie i małe litery, cyfry oraz 2 znaki specjalne</Styled.h6>
        <Styled.Actions>
          <div>
            <Button onClick={onClose} variant="outlined" loading={isUpdatingPassword || isSaving}>
              Anuluj
            </Button>
            <Button onClick={handleSubmit} loading={isUpdatingPassword || isSaving}>
              Zapisz
            </Button>
          </div>
        </Styled.Actions>
      </Styled.Form>
    </Modal>
  );
};

NewPasswordModal.propTypes = {
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};
